export default {"src":"/_next/static/media/0x639a647fbe20b6c8ac19e48e2de44ea792c62c5c.ef6ecb81.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};